import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import { FnrPopover } from "UI/FnrPopover2";
import { HoverChild, HoverParent } from "UI/HoverChildren";

import MoreOptionsContent from "./MoreOptionsContent";

export default function MoreOptionsSignupBoardButton() {
  const buttonRef = useRef();
  const [showPopover, setShowPopover] = useState(false);

  const handleClick = () => {
    setShowPopover((current) => !current);
  };

  return (
    <>
      <Wrapper>
        <HoverParent
          hoverStyle={{
            background: "rgba(0,0,0,.07)",
            borderRadius: 6,
          }}
        >
          <Button>
            <HoverChild forceHover={showPopover}>
              <ButtonInside onClick={handleClick} ref={buttonRef}>
                <>
                  <i className="fas fa-tools" />
                  &nbsp; Respondent Options
                </>
              </ButtonInside>
            </HoverChild>
          </Button>
        </HoverParent>
      </Wrapper>

      <FnrPopover
        show={showPopover}
        buttonRef={buttonRef}
        onShouldClose={() => setShowPopover(false)}
        color="white"
      >
        <MoreOptionsContent setShowPopover={setShowPopover} />
      </FnrPopover>
    </>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Button = styled.div`
  margin-left: 0;
  font-weight: 400;
  margin-left: 2px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #8b169c 0%, #9f35b0 100%);
    border-radius: 6px;
    z-index: 0;
    opacity: 0;
    transition: opacity 0.2s;
  }
`;

const ButtonInside = styled.div`
  padding: 6px 12px;
  font-size: 13px;
  position: relative;
  z-index: 100;
  cursor: pointer;
  user-select: none;
  transition: transform 0.2s;
  color: var(--fnBlue);

  &:active {
    transform: scale(0.9);
  }
`;
